module.exports = __webpack_public_path__ + "static/media/ipad_device.ef541600.jpg";